import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { currencies, countries } from 'country-data';
import uuid from 'uuid';
import { Button, Table, Popup, Loader, Flag, Label, Icon, Modal } from 'semantic-ui-react';
import moment from 'moment';
import numeral from 'numeral';
import { withRouter } from 'react-router';
import CAMPAIGN_TYPES from '../../utils/campaign-types';
import ConfirmationModal from '../../components/confirmation-modal';
import CampaignStatusComponent from './campaign-status-component';
import { compose } from 'recompose';
import hasRESTClient from '../../hocs/has-rest-client';
import hasOrgansation from '../../hocs/has-organisation';

const cf = num => numeral(num).format('0,0');

const loadingRowStyle = {
  height: 350,
};

const shopifyLogoStyle = {
  height: '1.2em',
};

const rowStyle = {
  cursor: 'pointer',
};
const labelStyle = {
  width: '100%',
};

const brandLabelStyle = {
  marginLeft: '0',
  marginTop: '2px',
};

const renderCurrency = code => {
  const currency = _.find(currencies.all, ['code', code]);
  return currency ? currency.symbol : '';
};

const renderCountry = code => {
  if (!code) return '-';
  const country = _.find(countries.all, ['alpha2', code]);
  return (
    <Popup
      trigger={
        <Flag name={_.toLower(country.alpha2)} />
      }
      content={country.name}
    />
  );
};

const LoadingTableRow = () => (
  <Table.Row style={loadingRowStyle}>
    <Table.Cell colSpan={8}>
      <Loader active inline="centered" content="Loading campaigns..." />
    </Table.Cell>
  </Table.Row>
);

const handleClick = ({ router, campaignType, campaignId, canLoadFast }) => {
  const isACR = campaignType === 'ACR';

  const campUrl = `/campaign/${campaignId}/collaborations${canLoadFast ? '?fast=true' : ''}`;
  const campaignUrl = isACR ? `/acr-campaign/${campaignId}` : campUrl;
  router.push(campaignUrl);
};

class CampaignsTable extends React.Component {
  constructor() {
    super();
    this.state = {
      displayDeleteModal: false,
      campaignToBeDeleted: null,
      campaigns: [],
    };
  }

  componentDidMount() {
  }

  onSuperAdminDelete = async () => {
    const { userInfo: { organisationId } } = this.props;
    const {
      campaignToBeDeleted,
      campaigns,
    } = this.state;
    const { restClient } = this.props;
    const { campaignId } = campaignToBeDeleted;
    console.log('campaignToBeDeleted', campaignToBeDeleted);

    restClient.patch(`campaigns/${campaignId}`, {
      data: {
        attributes: {
          status: 'DELETED',
        },
      },
    });

    console.log(organisationId);

    const deleteCacheURL = `/organisations/${organisationId}/cache`;

    await restClient({
      method: 'DELETE',
      url: deleteCacheURL,
      baseURL: process.env.REACT_APP_CAMPAIGNS_GET_URL,
    });

    this.setState({
      displayDeleteModal: false,
      campaignToBeDeleted: null,
      campaigns: _.reject(campaigns, c => (c.campaignId === campaignId)),
    });
  }

  openDeleteModal = record => {
    this.setState({
      displayDeleteModal: true,
      campaignToBeDeleted: record,
    });
  }

  closeDeleteModal = () => {
    this.setState({
      displayDeleteModal: false,
      campaignToBeDeleted: null,
    });
  }

  getWorkflow = workflow => {
    if (workflow === 'ABBLY_V1') return 'UK (global) Store';
    if (workflow === 'ABBLY_V1_US') return 'US Store';
    return workflow;
  }

  render() {
    const {
      records,
      router,
      onDelete,
      onArchive,
      onUnarchive,
      listType,
      isLoadingCampaigns,
      isCompact,
      isUserSuperAdmin,
    } = this.props;

    const {
      displayDeleteModal,
      campaignToBeDeleted,
      campaigns,
    } = this.state;


    const displayCampaigns = isCompact || _.isEmpty(campaigns) ? records : campaigns;

    if (!isCompact && _.isEmpty(campaigns)) {
      this.setState({
        campaigns: records,
      });
    }

    console.log('campaigns', displayCampaigns);

    return (
      <Table padded selectable={!isLoadingCampaigns} textAlign="center">
        {displayDeleteModal &&
        <ConfirmationModal
          headerText="Deleting Campaign"
          bodyText={`Are you sure you would like to delete the
        campaign ${campaignToBeDeleted.campaignName} created
        by ${campaignToBeDeleted.campaignCreatedBy}?`}
          onCancel={this.closeDeleteModal}
          onConfirm={this.onSuperAdminDelete}
        />}
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign="left" width="four">Name</Table.HeaderCell>
            { !isCompact && <Table.HeaderCell>Country</Table.HeaderCell> }
            <Table.HeaderCell>Type<br />Status</Table.HeaderCell>
            <Table.HeaderCell>Budget</Table.HeaderCell>
            { !isCompact && <Table.HeaderCell>Allocated budget</Table.HeaderCell>}
            <Table.HeaderCell>Assets</Table.HeaderCell>
            <Table.HeaderCell>Influencers</Table.HeaderCell>
            <Table.HeaderCell>TMs</Table.HeaderCell>
            <Table.HeaderCell>Integrations</Table.HeaderCell>
            <Table.HeaderCell>Created</Table.HeaderCell>
            {
              listType &&
              <Table.HeaderCell textAlign="center">Actions</Table.HeaderCell>
            }
          </Table.Row>
        </Table.Header>
        <Table.Body>
          { isLoadingCampaigns && <LoadingTableRow /> }
          {
            !isLoadingCampaigns && _.map(displayCampaigns, record => {
              const { campaignType, campaignId, campaignCanLoadFast: canLoadFast } = record;
              const isLarge = record.influencersCount > 60;
              const clf = isLarge && canLoadFast;
              const onClickListener = () => handleClick({ router, campaignType, campaignId, canLoadFast: clf });
              const withFacebookMarketingIntegration = _.get(record, 'marketingCampaignsCount', 0) > 0;
              const isShopifyCampaign = _.get(record, 'isShopifyCampaign');
              const withGoogleIntegration = !_.isEmpty(_.get(record, 'campaignBaseTrackingUrl', ''));
              const hasIntegrations = withFacebookMarketingIntegration || withGoogleIntegration || isShopifyCampaign;
              return (
                <Table.Row
                  style={rowStyle}
                  key={uuid()}
                  verticalAlign="middle"
                >
                  <Table.Cell onClick={onClickListener} textAlign="left">
                    <div>
                      <h4>{ record.campaignName }</h4>
                    </div>
                    {
                      record.campaignBrand &&
                      <Label style={brandLabelStyle}>
                        Brand
                        <Label.Detail>{_.toUpper(record.campaignBrand)}</Label.Detail>
                      </Label>
                    }
                    {
                      record.campaignWorkflow &&
                      <Label style={brandLabelStyle} color="blue" basic>
                        Workflow
                        <Label.Detail>
                          {_.toUpper(this.getWorkflow(record.campaignWorkflow))}
                        </Label.Detail>
                      </Label>
                    }

                  </Table.Cell>
                  {
                    !isCompact &&
                    <Table.Cell onClick={onClickListener} singleLine>
                      { renderCountry(_.get(record, 'campaignCountry')) }
                    </Table.Cell>
                  }
                  <Table.Cell onClick={onClickListener} >
                    <Popup
                      trigger={
                        <Label
                          style={labelStyle}
                          color={CAMPAIGN_TYPES[campaignType].color}
                          basic
                          size="tiny"
                          content={CAMPAIGN_TYPES[campaignType].shortName}
                        />
                      }
                      content={CAMPAIGN_TYPES[campaignType].fullName}
                    />
                    <CampaignStatusComponent
                      endDate={record.campaignEndDate}
                      liveDate={record.campaignLiveDate}
                    />
                  </Table.Cell>
                  <Table.Cell onClick={onClickListener} singleLine>
                    {
                      record.campaignCurrency && renderCurrency(record.campaignCurrency)
                    } { cf(record.campaignBudget) }
                  </Table.Cell>

                  {
                    !isCompact &&
                    <Table.Cell onClick={onClickListener}>
                      {
                        record.campaignCurrency && renderCurrency(record.campaignCurrency)
                      } { cf(record.allocatedBudget) }
                    </Table.Cell>
                  }
                  <Table.Cell onClick={onClickListener}>
                    { record.totalAssetsCount }
                  </Table.Cell>
                  <Table.Cell onClick={onClickListener}>
                    { record.influencersCount }
                  </Table.Cell>
                  <Table.Cell onClick={onClickListener}>
                    { record.teamMemberCount }
                  </Table.Cell>
                  <Table.Cell>
                    {
                      !hasIntegrations && <span>None</span>
                    }
                    { withFacebookMarketingIntegration &&
                    <Popup
                      content="Facebook Ads Campaign" trigger={
                        <Icon color="blue" name="facebook" />
                      }
                    />
                    }
                    { isShopifyCampaign &&
                    <Popup
                      content="Shopify Campaign" trigger={
                        <img
                          style={shopifyLogoStyle}
                          src="/icons/shopify.svg"
                          alt="Shopify"
                        />
                      }
                    />
                    }
                    { withGoogleIntegration &&
                    <Popup
                      content="Google Ads Campaign" trigger={
                        <Icon color="red" name="google" />
                      }
                    />
                    }
                  </Table.Cell>
                  <Table.Cell onClick={onClickListener}>
                    { record.campaignCreatedBy } on { moment(record.campaignCreatedDate).format('DD/MM/YY') }
                  </Table.Cell>
                  {
                    listType && <Table.Cell>
                      {
                        listType === 'ACTIVE' && isUserSuperAdmin &&
                        <Popup
                          content="Delete this campaign"
                          trigger={
                            <Button
                              onClick={() => this.openDeleteModal(record)}
                              icon="x"
                              circular
                              inverted
                              color="red"
                            />
                          }
                        />
                      }
                      {
                        listType === 'ACTIVE' && !isUserSuperAdmin &&
                        <Popup
                          content="Archive this campaign"
                          trigger={
                            <Button
                              onClick={() => onArchive(record.campaignPermissionId)}
                              circular
                              icon="archive"
                              color="orange"
                              inverted
                            />
                          }
                        />
                      }
                      {
                        listType === 'ARCHIVED' &&
                        <div>
                          <Popup
                            content="Unarchive this campaign"
                            trigger={
                              <Button
                                onClick={() => onUnarchive(record.campaignPermissionId)}
                                circular
                                icon="undo"
                                color="green"
                                inverted
                              />
                            }
                          />
                        &nbsp;
                          <Popup
                            content="Delete this campaign"
                            trigger={
                              <Button
                                onClick={() => onDelete(record.campaignPermissionId)}
                                icon="x"
                                circular
                                inverted
                                color="red"
                              />
                            }
                          />
                        </div>
                      }
                    </Table.Cell>

                  }
                </Table.Row>
              );
            })
          }
        </Table.Body>
      </Table>
    );
  }
}

CampaignsTable.propTypes = {
  records: PropTypes.array.isRequired,
  router: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
  onArchive: PropTypes.func.isRequired,
  onUnarchive: PropTypes.func.isRequired,
  listType: PropTypes.string.isRequired,
  isLoadingCampaigns: PropTypes.bool.isRequired,
  isCompact: PropTypes.bool,
  isUserSuperAdmin: PropTypes.bool,
};

export default compose(hasRESTClient, hasOrgansation, withRouter)(CampaignsTable);



/** WEBPACK FOOTER **
 ** ./src/components/campaigns-table/index.js
 **/